import React from "react";

interface BlueprintLogoProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const BlueprintLogo: React.FC<BlueprintLogoProps> = ({ color = "white", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="147"
    height="22"
    viewBox="0 0 147 22"
    fill="none"
    {...props}
  >
    <path
      d="M7.056 8.304C7.128 8.304 7.176 8.304 7.224 8.304C8.088 8.256 8.544 7.992 8.904 7.608C9.264 7.2 9.48 6.6 9.48 5.976C9.48 5.352 9.264 4.752 8.904 4.344C8.52 3.936 8.04 3.648 7.056 3.648H3.624V8.304H7.056ZM7.056 0.0239997C8.928 0.0239997 10.536 0.768 11.592 1.896C12.624 3.048 13.104 4.536 13.104 5.976C13.104 7.392 12.648 8.808 11.664 9.936C13.056 11.136 13.824 12.84 13.824 14.544C13.824 17.664 11.184 20.808 7.056 20.808L0.0720001 20.784H0.048L0 0.0239997H7.056ZM7.248 11.928C7.176 11.928 7.128 11.928 7.056 11.928H3.624V17.184H7.056C9.552 17.184 10.2 15.864 10.2 14.544C10.2 13.248 9.576 11.976 7.248 11.928Z"
      fill={color}
    />
    <path d="M16.2188 0H19.8428V17.16H31.6747V20.784H16.2188V0Z" fill={color} />
    <path
      d="M32.8828 0.0959988H36.5068V11.808C36.5068 16.272 39.1228 17.904 41.7388 17.904C44.3548 17.904 46.9708 16.272 46.9708 11.808V0.0959988H50.5948V11.808C50.5948 17.88 46.1548 21.528 41.7388 21.528C37.2988 21.528 32.8828 17.88 32.8828 11.808V0.0959988Z"
      fill={color}
    />
    <path
      d="M64.0434 7.104V10.728C61.2834 10.728 60.1314 11.208 58.6914 11.784C57.9714 12.096 57.1314 12.432 56.1474 12.696V17.16H65.9634V20.784H52.5234V0H65.4834V3.648H56.1474V8.904C56.5074 8.76 56.8914 8.616 57.3234 8.424C58.8114 7.824 60.7794 7.104 64.0434 7.104Z"
      fill={color}
    />
    <path
      d="M67.8984 0H74.9544C79.4184 0 82.1784 3.432 82.1784 6.816C82.1784 10.176 79.4184 13.608 74.9544 13.608H71.5224V20.784H67.8984V0ZM71.5224 9.984H74.9544C77.7384 9.984 78.5544 8.424 78.5544 6.816C78.5544 5.184 77.7384 3.648 74.9544 3.648H71.5224V9.984Z"
      fill={color}
    />
    <path
      d="M84.1172 0H91.1732C95.6372 0 98.3972 3.432 98.3972 6.816C98.3972 9.12 97.1012 11.472 94.8212 12.72C95.1812 13.248 95.4932 13.776 95.8292 14.28C96.4532 15.264 97.1012 16.128 97.7732 16.68C98.4212 17.232 99.0452 17.544 100.077 17.544V21.168C98.2052 21.168 96.5972 20.448 95.4452 19.464C94.2692 18.504 93.4772 17.328 92.7812 16.248C92.0852 15.192 91.5092 14.232 91.0052 13.68C90.9812 13.656 90.9812 13.632 90.9572 13.608H87.7412V20.784H84.1172V0ZM87.7412 9.984H91.1732C93.9572 9.984 94.7732 8.424 94.7732 6.816C94.7732 5.184 93.9572 3.648 91.1732 3.648H87.7412V9.984Z"
      fill={color}
    />
    <path d="M101.883 0H105.507V20.784H101.883V0Z" fill={color} />
    <path
      d="M107.906 0H111.53C111.53 2.136 112.274 3.6 113.57 5.04C114.866 6.456 116.738 7.752 118.754 9.072C120.506 10.248 122.378 11.424 123.986 12.96V0H127.61V20.784H123.986C123.986 18.816 123.242 17.448 121.946 16.08C120.65 14.688 118.754 13.416 116.738 12.096C114.986 10.92 113.114 9.696 111.53 8.136V20.784H107.906V0Z"
      fill={color}
    />
    <path d="M129.539 0H146.411V3.648H139.787V20.784H136.163V3.648H129.539V0Z" fill={color} />
  </svg>
);

export default BlueprintLogo;
